import React from 'react';
import PropTypes from 'prop-types';

import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';

import { DISPLAY_TYPE_TO_COMPONENT } from '../utils/displayTypeToComponent';
import { DISPLAY_TYPES } from '../utils/constants';

export default function PullQuote({ sliceData }) {
  const Component = DISPLAY_TYPE_TO_COMPONENT[sliceData.primary.display_type];

  return (
    <div className="PrismicPullQuote container">
      <div className="row">
        <Component content={sliceData.primary.content} />
      </div>
    </div>
  );
}

PullQuote.propTypes = {
  sliceData: PropTypes.shape({
    primary: PropTypes.shape({
      display_type: PropTypes.oneOf(Object.values(DISPLAY_TYPES)),
      content: StructuredTextPropTypes.isRequired
    }).isRequired
  }).isRequired
};
